import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-kpa-inside-spinner',
    templateUrl: './kpa-inside-spinner.component.html',
    styleUrls: ['./kpa-inside-spinner.component.css'],
    standalone: false
})
export class KpaInsideSpinnerComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
